import Image from "../fragments/Image";
import Gallery from "../fragments/Gallery";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Media({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const mediaRevealRef = useReveal({ once: true });
    const textRevealRef = useReveal({ once: true });

    if (block.alignment === 'left') {
        return (
            <div className={`c-page__block c-page__block--text-image`}>
                <div className={`l-grid`}>
                    <div className={`l-grid__col l-grid__col--m-4-12 l-grid__col--l-7-12 c-transition-in`} ref={mediaRevealRef}>
                        <Image 
                            src={block.img_src || []} 
                            width={block.img_width} 
                            height={block.img_height} 
                            alt={block.img_alt || ''} 
                        />
                    </div>
                    <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--m-push-1-12 l-grid__col--l-4-12 c-transition-in`} ref={textRevealRef}>
                        <div className="scope-text" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className={`c-page__block c-page__block--text-image`}>
                <div className={`l-grid`}>
                    <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--l-4-12 c-transition-in`} ref={textRevealRef}>
                        <div className="scope-text" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    </div>
                </div>
                <div className={`l-grid__col l-grid__col--m-4-12 l-grid__col--m-push-1-12 l-grid__col--l-7-12 c-transition-in`} ref={mediaRevealRef}>
                    <Image 
                        src={block.img_src || []} 
                        width={block.img_width} 
                        height={block.img_height} 
                        alt={block.img_alt || ''} 
                    />
                </div>
            </div>
        );
    }
}